// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"98936f57","488":"94982005"}[chunkId] + ".chunk.js";
};